import { ICONES_PLEINES, type NomIconePleine } from '../config/icons';

interface Props {
  nom: NomIconePleine;
  className?: string;
}

/**
 * Icône SVG pleine, jeu 20×20 de la maquette (lecture, pause, étoile, coche).
 * Pendant de `Icone`, qui rend les tracés au trait de la grille 24×24.
 */
export function IconePleine({ nom, className = 'w-4 h-4' }: Props): JSX.Element {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
      <path fillRule="evenodd" clipRule="evenodd" d={ICONES_PLEINES[nom]} />
    </svg>
  );
}
